export default __webpack_public_path__ + "static/media/by-nc-sa.35157979.svg";